// extracted by mini-css-extract-plugin
module.exports = {"oneColumn__content":"OneColumn--oneColumn__content--1UlU-","offset":"OneColumn--offset--1WveB"};